export const providerColors = {
  openai: '#10B981',
  anthropic: '#F59E0B',
  google: '#3B82F6',
  mistral: '#EC4899',
  meta: '#8B5CF6',
  other: '#707070',
};

export const tooltipStyle = {
  background: '#171719',
  border: '1px solid #2A2A30',
  borderRadius: 8,
  fontSize: 12,
  color: '#FFFFFF',
};
export const labelStyle = { color: '#FFFFFF' };

export const seed = (i, salt = 1) => {
  const x = Math.sin(i * 9301 + salt * 49297) * 233280;
  return x - Math.floor(x);
};

export const fmt = n => {
  const num = Number(n) || 0;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(num >= 10_000_000 ? 0 : 1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(num >= 10_000 ? 0 : 1)}K`;
  return Math.round(num).toString();
};

export const fmtUSD = n => {
  const num = Number(n) || 0;
  return `$${num >= 1000 ? `${(num / 1000).toFixed(1)}K` : num.toFixed(2)}`;
};

export const providerLabel = p => {
  const v = (p || '').toLowerCase();
  if (v.includes('anthropic') || v.includes('claude')) return 'anthropic';
  if (v.includes('google') || v.includes('gemini')) return 'google';
  if (v.includes('mistral')) return 'mistral';
  if (v.includes('meta') || v.includes('llama')) return 'meta';
  if (v.includes('openai') || v.includes('gpt')) return 'openai';
  return 'other';
};

export function getDateRange(days) {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - days);
  const formatDate = date => date.toISOString().split('T')[0];
  return { start_date: formatDate(start), end_date: formatDate(today) };
}

export function buildDayLabels(days = 14) {
  const today = new Date();
  return Array.from({ length: days }, (_, i) => {
    const d = new Date(today);
    d.setDate(d.getDate() - (days - 1 - i));
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  });
}
